import { render, staticRenderFns } from "./ListItemChips.vue?vue&type=template&id=c5da4d9c&scoped=true&"
import script from "./ListItemChips.vue?vue&type=script&lang=js&"
export * from "./ListItemChips.vue?vue&type=script&lang=js&"
import style0 from "./ListItemChips.vue?vue&type=style&index=0&id=c5da4d9c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5da4d9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VListItem})
